var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-4 pb-6 justify-flex-start items-flex-start",
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              attrs: {
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                placeholder: "Search by name",
                isIcon: _vm.yes,
                debounceTime: 500,
              },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = $$v
                },
                expression: "name",
              },
            }),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("ProfileCountrySelect", {
                  attrs: { multiple: "", getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.countries,
                    callback: function ($$v) {
                      _vm.countries = $$v
                    },
                    expression: "countries",
                  },
                }),
              ],
              1
            ),
            _c("RegionInput", {
              attrs: {
                countries: _vm.countries,
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                debounceTime: 500,
                isIcon: _vm.yes,
                multiple: "",
              },
              model: {
                value: _vm.states,
                callback: function ($$v) {
                  _vm.states = $$v
                },
                expression: "states",
              },
            }),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("TitlesMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.titles,
                    callback: function ($$v) {
                      _vm.titles = $$v
                    },
                    expression: "titles",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("SkillsMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.skillsIds,
                    callback: function ($$v) {
                      _vm.skillsIds = $$v
                    },
                    expression: "skillsIds",
                  },
                }),
              ],
              1
            ),
            !_vm.hideManagersFilter
              ? _c(
                  "FormGroup",
                  { attrs: { debounceTime: 500 } },
                  [
                    _c("ManagersMultiselect", {
                      attrs: {
                        placeholder: `Manager`,
                        getParentcontainerStyle: "smallHeight",
                      },
                      model: {
                        value: _vm.managersIds,
                        callback: function ($$v) {
                          _vm.managersIds = $$v
                        },
                        expression: "managersIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "FormGroup",
              { attrs: { debounceTime: 500 } },
              [
                _c("ProjectsMultiselect", {
                  attrs: {
                    invalid: _vm.failed,
                    placeholder: "Client",
                    getcontainerStyle: "smallHeight",
                  },
                  model: {
                    value: _vm.projectsIds,
                    callback: function ($$v) {
                      _vm.projectsIds = $$v
                    },
                    expression: "projectsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                attrs: {
                  debounceTime: 500,
                  placeholder: `Select availability`,
                },
              },
              [
                _c("ProfileAvailabilitySelect", {
                  attrs: {
                    placeholder: "`Select availability`",
                    getParentCustom: "smallHeight",
                  },
                  model: {
                    value: _vm.available,
                    callback: function ($$v) {
                      _vm.available = $$v
                    },
                    expression: "available",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("UiButtonMessage", {
          attrs: {
            buttonClass: "customAdd",
            buttonText: "Reset",
            textClass: "customText customOnlyText",
          },
          on: { click: _vm.handleReset },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }